import Slider from './Slider.vue';

export default [
  Slider,
];
